import { render, staticRenderFns } from "./CanvasSyncConfigPanel.vue?vue&type=template&id=ccf7e1b2"
import script from "./CanvasSyncConfigPanel.vue?vue&type=script&lang=ts"
export * from "./CanvasSyncConfigPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports